import { render, staticRenderFns } from "./ajustes.vue?vue&type=template&id=5a7ed2a8&scoped=true"
import script from "./ajustes.vue?vue&type=script&lang=js"
export * from "./ajustes.vue?vue&type=script&lang=js"
import style0 from "./ajustes.vue?vue&type=style&index=0&id=5a7ed2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7ed2a8",
  null
  
)

export default component.exports